import { render } from "./ProductImport.vue?vue&type=template&id=0658c801&scoped=true"
import script from "./ProductImport.js?vue&type=script&lang=js&external"
export * from "./ProductImport.js?vue&type=script&lang=js&external"

import "./ProductImport.scss?vue&type=style&index=0&id=0658c801&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0658c801"]])

export default __exports__